import React from 'react';
import DocumentsIndex from "../../documents";
export function documentsRoutes() { return [{ path: '/documents', element: /*#__PURE__*/ React.createElement(DocumentsIndex, null) }]; }
